jQuery( document ).ready( function( $ ) {
	// Input fields must be within the same container.
	const whqContainer = $( '<div class="boldlabels-wc-pao-addon--hqw-container"></div>' );
	$( '.wc-pao-addon-bredd-mm' ).before( whqContainer );

	// Move whq fields to whqContainer.
	$( '.wc-pao-addon-bredd-mm' ).appendTo( whqContainer );
	$( '.wc-pao-addon-hojd-mm' ).appendTo( whqContainer );
	$( '.wc-pao-addon-antal' ).appendTo( whqContainer );

	// Placeholders.
	$( '.wc-pao-addon-bredd-mm input' ).attr( 'placeholder', 'min. 20 mm' );
	$( '.wc-pao-addon-hojd-mm input' ).attr( 'placeholder', 'min. 20 mm' );
	$( '.wc-pao-addon-antal input' ).attr( 'placeholder', 'min. 1 st' );
} );
